<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> MATERIAL </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-toolbar-title v-if="material.id"
          >{{ material.id }} -
          {{ material.name.toUpperCase() }}</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn outlined color="grey darken-3" @click="goToBackList()">
          <v-icon left>mdi-chevron-left</v-icon> Voltar
        </v-btn>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid>
          <alert
            :visible="!!error"
            dark
            type="error"
            :message="error"
            :clickClose="() => (error = '')"
          />
          <v-row>
            <v-col cols="12" xs="12" md="2">
              <v-text-field
                v-model="material.code"
                class="text-field-uppercase"
                label="Código"
                dense
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="10"> </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" md="4">
              <v-text-field
                v-model="material.name"
                class="text-field-uppercase"
                label="Nome"
                dense
                outlined
                required
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="8"> </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn color="blue darken-3" dark class="mt-5" @click="validate">
                <v-icon left>mdi-send</v-icon> Salvar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
  </div>
</template>

<script>
import * as API from "@/api/requests/MaterialRequest";

import Alert from "@/components/Alert";

export default {
  components: {
    Alert,
  },
  data: () => ({
    loading: false,
    error: "",
    material: {
      id: "",
      code: "",
      name: "",
      status: 1,
    },
    valid: true,
    lazy: false,
    rules: {
      required: (value) => !!value || "Campo Obrigatorio",
    },
  }),
  computed: {},
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      if (this.$route.params.id) {
        this.getMaterial(this.$route.params.id);
      }
    },
    async getMaterial(id) {
      // this.showLoading();
      this.loading = true;
      try {
        this.material = await API.getById(id);
      } catch (error) {
        this.material = {};
        console.log(error);
        //this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    goToBackList() {
      this.$router.push({ name: "Material" });
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.material.code = this.material.code.toUpperCase();
        this.material.name = this.material.name.toUpperCase();
        this.material.status = this.material.status ? 1 : 0;
        let data = { ...this.material };
        // let data = new URLSearchParams(this.material);
        if (this.material.id === "") {
          this.post(data);
        } else {
          this.update(this.material.id, data);
        }
      }
    },
    async post(data) {
      // this.showLoading();
      this.loading = true;
      try {
        let res = await API.post(data);
        console.log(res);
        this.goToBackList();
      } catch (error) {
        console.log(error);
        this.error = `${error.response.data.message} - ${error.response.data.material.code}: ${error.response.data.material.name}`;
      } finally {
        this.loading = false;
      }
    },
    async update(id, data) {
      this.loading = true;
      try {
        await API.update(id, data);
        this.goToBackList();
      } catch (error) {
        this.error = `${error.response.data.message} - ${error.response.data.material.code}: ${error.response.data.material.name}`;
      } finally {
        this.loading = false;
      }
    },
    getLabelStatus(status) {
      return status == 1 ? "Ativo" : "Desativado";
    },
  },
};
</script>
<style>
.text-field-uppercase input {
  text-transform: uppercase;
}
</style>
